// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--EakdZ","info-block":"a10a3f92e9--info-block--v4y5S"};